import { render, staticRenderFns } from "./guideBox.vue?vue&type=template&id=190bc224&scoped=true&lang=html&"
import script from "./guideBox.vue?vue&type=script&lang=js&"
export * from "./guideBox.vue?vue&type=script&lang=js&"
import style0 from "./guideBox.vue?vue&type=style&index=0&id=190bc224&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190bc224",
  null
  
)

export default component.exports